import { Tenant } from "./tenant";

export class Organization {
  name: string;
  description: string;
  address: string;
  address2: string;
  city: string;
  country: string;
  email: string;
  phone: string | object;
  region: string;
  zip: string;
  tenant: Tenant;
  entryDate: number;
  expirationDate: number;
  uuid: string;
}
